import script from "./apply-reschedule-to-cohort.vue?vue&type=script&setup=true&lang=js"
export * from "./apply-reschedule-to-cohort.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__